import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';
import ReactHtmlParser from 'react-html-parser';
import { useIntl } from 'gatsby-plugin-react-intl';

import Container from '../../Core/Container';
import RichText from '../../Core/RichText';

import {
  ArticleWrapper,
  Article,
  AdditionalArticles,
  Ctas,
  StyledLink,
  ButtonWrapper,
  PaginationBtn,
} from './styles';

const link = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <>{children}</>,
  },
};

const CompanyUpdates = ({ data }) => {
  if (!data) return null;
  const ref = React.createRef();
  const intl = useIntl();

  const scrollToPagination = () => {
    ref.current.scrollIntoView();
    const offset = -130;
    setTimeout(() => {
      window.scrollBy(0, offset);
    }, 10);
  };
  const [noOfArticles, setnoOfArticles] = useState(0);

  const { elements, sectionContainerHeading, ctas } = data;

  const showUpdatesMsg =
    intl.locale === 'en'
      ? 'Show previous updates'
      : 'Afficher les messages précédents';

  const hideUpdatesMsg =
    intl.locale === 'en'
      ? 'Hide previous updates'
      : 'Masquer les messages précédents';

  return (
    <Container as="section" id="pcf-updates">
      {/* Check if the component type is 'articles', if so display the first article and hide the remainder behind a show more button */}
      <ArticleWrapper>
        <RichText document={sectionContainerHeading} />
        <Article>
          {ReactHtmlParser(
            elements[0].paragraphHeading.childMarkdownRemark.html,
          )}
          <div>
            {ReactHtmlParser(
              elements[0].paragraphCopy.childMarkdownRemark.html,
            )}
          </div>
        </Article>
        <AdditionalArticles
          style={{ visibility: noOfArticles > 0 ? 'visible' : 'hidden' }}
        >
          {elements.map(({ id, paragraphCopy, paragraphHeading }, index) => {
            return index > 0 && index < noOfArticles ? (
              <Article key={id}>
                {ReactHtmlParser(paragraphHeading.childMarkdownRemark.html)}
                <div>
                  {ReactHtmlParser(paragraphCopy.childMarkdownRemark.html)}
                </div>
              </Article>
            ) : null;
          })}
        </AdditionalArticles>
        {elements.length > 1 ? (
          <ButtonWrapper>
            {noOfArticles < elements.length && (
              <PaginationBtn
                id="pagination"
                type="button"
                onClick={() => {
                  if (noOfArticles < elements.length) {
                    setnoOfArticles(noOfArticles + 3);
                  }
                }}
              >
                <span>{showUpdatesMsg}</span>
              </PaginationBtn>
            )}
            {noOfArticles > 0 && (
              <PaginationBtn
                id="pagination"
                className="hide"
                type="button"
                ref={ref}
                onClick={() => {
                  if (noOfArticles > 0) {
                    setnoOfArticles(noOfArticles - 3);
                    scrollToPagination();
                  }
                }}
              >
                <span>{hideUpdatesMsg}</span>
              </PaginationBtn>
            )}
          </ButtonWrapper>
        ) : null}
      </ArticleWrapper>
      {ctas && (
        <Ctas>
          {ctas.map(cta => {
            if (cta.hideFrench === true) return null;
            return (
              <StyledLink key={cta.id} data={cta}>
                <RichText document={cta.label} options={link} />
              </StyledLink>
            );
          })}
        </Ctas>
      )}
    </Container>
  );
};

CompanyUpdates.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default CompanyUpdates;
